import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Sometimes your worst code is your best code",
  "description": "",
  "published": "2019-11-08T00:00:00.000Z",
  "redirect_from": ["/blog/sometimes-your-worst-code-is-your-best-code/swizec/9235"],
  "categories": "Technical",
  "hero": "./img/techletter.app-screenshot-1573233518980.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You know what they say: Arguing with an engineer is like wrestling with a pig in the mud. After 5 hours you realize the pig likes it.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/thekitze/status/1191748577363726341"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "83.40807174887892%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'334\\'%20viewBox=\\'0%200%20400%20334\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M33%2024c-3%202-3%203-2%2010%202%2010%2010%2014%2013%207s4-14%202-17c-3-3-10-3-13%200m1%207c-2%205%201%2011%204%208h4c2%201%203%200%203-4h-3c-1-1-1-1%201-3%203-3%202-4-4-4-4%200-4%200-5%203m132%20243l-1%204-1%202c-3%200-2%203%200%206%205%204%2013%201%2011-4l-1-1v-2c1-5-5-8-8-5m21%200l-3%203-3%203v1c-1%200%200%203%202%205%204%205%2013%200%2012-6-1-5-8-9-8-6m32%201c-2%203-3%208-1%2010%202%203%208%203%2010%201l1-2-1-1%202-2c3%200%200-6-4-6l-3-1c-1-1-2%200-4%201m19-1c-3%203-4%207-2%2010l2%203h3c2%201%202%200%202-3l1-4v4c0%204%202%204%205-1%203-6-6-13-11-9m18%202c-4%203-4%207-1%2010%207%206%2017-4%2010-11-3-3-5-3-9%201m19-1c-2%202-3%206-1%207l1%203c0%202%200%203%203%203%204%200%207-3%207-8%200-3%200-3-1-1%200%202-1%203-3%202s-2-1%200-2c3%200%203-3%201-4-3-2-5-2-7%200m16%200c-2%203-3%208-1%206l1%201c-2%205%207%208%2011%204%204-5%201-13-5-13l-6%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/501a1cfc6814b78b200a733a6bd385b8/ca0a1/techletter.app-screenshot-1573233518980.webp 223w", "/static/501a1cfc6814b78b200a733a6bd385b8/75680/techletter.app-screenshot-1573233518980.webp 445w", "/static/501a1cfc6814b78b200a733a6bd385b8/0ba47/techletter.app-screenshot-1573233518980.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/501a1cfc6814b78b200a733a6bd385b8/e92b6/techletter.app-screenshot-1573233518980.png 223w", "/static/501a1cfc6814b78b200a733a6bd385b8/e66bf/techletter.app-screenshot-1573233518980.png 445w", "/static/501a1cfc6814b78b200a733a6bd385b8/6af66/techletter.app-screenshot-1573233518980.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/501a1cfc6814b78b200a733a6bd385b8/6af66/techletter.app-screenshot-1573233518980.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Everyone loves a good fight about their tools. It's fun as heck, scares away all the normal people, and makes you feel smart. win-win-win what's not to love?`}</p>
    <p>{`Wasting time you could spend solving problems. You're paid to `}<em parentName="p">{`solve problems`}</em>{` not to "find the best way" to still not solve the problem. 😉`}</p>
    <p>{`Within reason.`}</p>
    <p>{`So I figured I'd share a couple gloriously disgusting hacks that made me take a shower right after. But they solved the problem.`}</p>
    <h2 {...{
      "id": "a-dirty-piece-of-js-in-jsx-that-made-1000-in-a-week"
    }}>{`A dirty piece of JS-in-JSX that made `}{`\\`}{`\\`}{`\\`}{`$1000 in a week`}</h2>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1184726187790061570"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "112.10762331838563%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'448\\'%20viewBox=\\'0%200%20400%20448\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2021c-5%203-7%208-7%2013l2%206c1%201%202%202%201%203-1%203%2013%207%2018%204%204-2%205-4%202-4s-4-3-1-5c1-1%203-2%204-1l1-1%202-3c2-1-1-9-5-10l-2-2c0-3-10-3-15%200m4%2010c0%203-1%204-4%205-3%202-3%205%201%209s7%202%2010-5c2-4%202-4-1-3-2%200-2%200-1%201v2l-3%201h-2c-2%202-4%200-2-2l2-2c2%202%204%200%203-2l-1-5-1-3-1%204m43%2095l-1%2010-1%205a4527%204527%200%20001%20198c0%204%203%208%2010%2011l5%203h126c99%200%20126-1%20129-2%204-1%2011-6%209-6l1-1%202-4%201-3c2%202%202-12%202-99a645%20645%200%2000-3-107v-9l-141-1H78v5m94%20271c-8%201-6%2014%202%2014%204%200%208-4%208-8%200-2-4-7-6-7l-4%201m15%201l-2%205c0%203%202%206%203%205v-1c-1-2%202-4%203-3%202%201%208-2%208-4%200-4-8-5-12-2m18%200l-2%205c0%203%202%206%203%206h1l2%201v-2c-2-2-1-4%202-4s4%201%201%204c-1%202-1%202%201%202%205%200%207-8%202-12-3-3-7-3-10%200m38%200c-4%203-4%208-1%2011%204%203%206%202%206-2l2-3v7l2-2c4-4%201-13-5-13l-4%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9131bb591ce12d4fc03c46e55365be54/ca0a1/techletter.app-screenshot-1573233520142.webp 223w", "/static/9131bb591ce12d4fc03c46e55365be54/75680/techletter.app-screenshot-1573233520142.webp 445w", "/static/9131bb591ce12d4fc03c46e55365be54/0ba47/techletter.app-screenshot-1573233520142.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9131bb591ce12d4fc03c46e55365be54/e92b6/techletter.app-screenshot-1573233520142.png 223w", "/static/9131bb591ce12d4fc03c46e55365be54/e66bf/techletter.app-screenshot-1573233520142.png 445w", "/static/9131bb591ce12d4fc03c46e55365be54/6af66/techletter.app-screenshot-1573233520142.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/9131bb591ce12d4fc03c46e55365be54/6af66/techletter.app-screenshot-1573233520142.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`A few weeks ago I had a problem. My `}<a parentName="p" {...{
        "href": "https://serverlesshandbook.dev"
      }}>{`Serverless Handbook`}</a>{` page was done, due in a few hours, and missing its most important ingredient: the opt-in wall.`}</p>
    <p>{`You see I had a paid ad spot in a React newsletter from Cooper Press that was going out to thousands of people in a few hours. I wanted to launch Serverless Handbook there as a free lead magnet.`}</p>
    <p>{`But it's not a lead magnet unless it asks for your email.`}</p>
    <p>{`Page is done – copied from Rebass's wonderful docs page – how hard can it be to add an email form?`}</p>
    <p>{`Yeah but I want each chapter to sort of tease you with its contents then fade out into an opt-in wall.`}</p>
    <p>{`Okay so render some of the content then add a React component with the form or whatever?`}</p>
    <p>{`Yeah but the content for each chapter is written in MDX – markdown with JSX. That means it gets parsed by a Gatsby plugin, munged into HTML, and injected into my page as one big blob.`}</p>
    <p><img parentName="p" {...{
        "src": "/3e45a447846c71418e60682a1d331448/media-6utVzLiyU9OuHbd70D-giphy-downsized-medium.gif",
        "alt": "thinking_hard giphy"
      }}></img></p>
    <p>{`One option was to implement the opt-in wall logic on every page itself. Go into the MDX and wrap paragraphs in conditionals. Do we show this or not?`}</p>
    <p>{`Ooooooor I could create this glorious hack`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/c2eac30f2090d32bc16a4910867d272b/a878e/lpJbo68.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "90.13452914798206%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'361\\'%20viewBox=\\'0%200%20400%20361\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M22%2023v159l1%20157h355V23l-178-1-178%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/c2eac30f2090d32bc16a4910867d272b/ca0a1/lpJbo68.webp 223w", "/static/c2eac30f2090d32bc16a4910867d272b/75680/lpJbo68.webp 445w", "/static/c2eac30f2090d32bc16a4910867d272b/8d1ba/lpJbo68.webp 890w", "/static/c2eac30f2090d32bc16a4910867d272b/3838e/lpJbo68.webp 1335w", "/static/c2eac30f2090d32bc16a4910867d272b/e11e5/lpJbo68.webp 1780w", "/static/c2eac30f2090d32bc16a4910867d272b/8df42/lpJbo68.webp 2048w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/c2eac30f2090d32bc16a4910867d272b/e92b6/lpJbo68.png 223w", "/static/c2eac30f2090d32bc16a4910867d272b/e66bf/lpJbo68.png 445w", "/static/c2eac30f2090d32bc16a4910867d272b/4ef49/lpJbo68.png 890w", "/static/c2eac30f2090d32bc16a4910867d272b/4e814/lpJbo68.png 1335w", "/static/c2eac30f2090d32bc16a4910867d272b/701e9/lpJbo68.png 1780w", "/static/c2eac30f2090d32bc16a4910867d272b/a878e/lpJbo68.png 2048w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/c2eac30f2090d32bc16a4910867d272b/4ef49/lpJbo68.png",
              "alt": "lpJbo68",
              "title": "lpJbo68",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`It worked. Free product, opt-in wall, made $1000 in its first week as a "pay what you want" offering.`}</p>
    <p>{`👌`}</p>
    <h3 {...{
      "id": "how-it-works"
    }}>{`How it works`}</h3>
    <p>{`It really is quite a nasty piece of work. We've got a React component that renders the paywall itself.`}</p>
    <p>{`Once React is done rendering we use a `}<inlineCode parentName="p">{`useEffectLayout`}</inlineCode>{` to run some vanilla JavaScript that manipulates the DOM directly. You're `}<em parentName="p">{`really`}</em>{` not supposed to do that with React.`}</p>
    <p>{`This JavaScript creates a `}<inlineCode parentName="p">{`div`}</inlineCode>{` with a fadeout white background, renders that over the main content, then repositions the paywall copy over it.`}</p>
    <p>{`Dirty but it works`}</p>
    <p><img parentName="p" {...{
        "src": "/b216f645f3d4d8a05348708cd2066750/mMOq3br.gif",
        "alt": null
      }}></img></p>
    <h2 {...{
      "id": "a-nasty-piece-of-work-that-got-80-people-paid-on-time"
    }}>{`A nasty piece of work that got 80 people paid on time`}</h2>
    <p>{`Another nasty piece of work happened at the dayjob.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1190393106601897984"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "166.3677130044843%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'665\\'%20viewBox=\\'0%200%20400%20665\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2020c-3%202-7%206-8%2010-1%203%201%2011%203%2011v1c0%202%202%204%203%203l-1-5c-2-4-2-4%200-3%204%201%208-6%205-9-1-1-1-1%201-1s2%201%202%203c0%205%201%206%204%206s3%200%202%204c-2%204-5%207-8%207-2%200-1%201%202%201%203%201%205%201%208-1%204-2%205-4%202-4-2%200-3-1-3-2%200-2%204-5%206-4l1-1%202-2c2-2-1-10-4-11l-4-2c-2-2-8-3-13-1m213%20101l-1%206v6h3c7%200%2010-6%206-10-3-3-7-4-8-2M47%20308l-1%20237c1%202%202%202%205%202l3%201c0%201%208%205%2014%206%2010%203%20261%202%20268%200l10-6%203-1c3%200%204%200%205-2l-1-237-153-1-153%201m138%20299c-3%202-2%207%200%2010l2%201v-2l1%201%201%201h1c1%202%203-1%204-4%201-6-6-11-9-7m-35%203c-1%202-4%203-4%201-1-1-1%200-1%201%200%206%208%209%2013%204%204-4%203-7-3-8-4%200-5%200-5%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9bda419b9a3d7b9c8090e05eed30d2f2/ca0a1/techletter.app-screenshot-1573233519017.webp 223w", "/static/9bda419b9a3d7b9c8090e05eed30d2f2/75680/techletter.app-screenshot-1573233519017.webp 445w", "/static/9bda419b9a3d7b9c8090e05eed30d2f2/0ba47/techletter.app-screenshot-1573233519017.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9bda419b9a3d7b9c8090e05eed30d2f2/e92b6/techletter.app-screenshot-1573233519017.png 223w", "/static/9bda419b9a3d7b9c8090e05eed30d2f2/e66bf/techletter.app-screenshot-1573233519017.png 445w", "/static/9bda419b9a3d7b9c8090e05eed30d2f2/6af66/techletter.app-screenshot-1573233519017.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/9bda419b9a3d7b9c8090e05eed30d2f2/6af66/techletter.app-screenshot-1573233519017.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`We use a 3rd party app to manage our fleet of shift workers. Person comes on our platform, creates a account, backend gives them an account on this other service, and there's some integration between us and them.`}</p>
    <p>{`The ops team uses that integration to run payroll.`}</p>
    <p>{`Guess what happened on October 27th? That's right, the integration suddenly and mysteriously died.`}</p>
    <p>{`We dug in and found that the API returns data in shift worker's individual timezones. `}<em parentName="p">{`Not`}</em>{` in our timezone or UTC like you'd expect. When we built the integration the API used our timezone.`}</p>
    <p>{`Nope, the API doesn't tell you which timezone each timestamp is in. Don't even get me started on API's that expect you to assume timezone from context. 😒`}</p>
    <p>{`We assume it's a bug, talk to support, and go on our merry way. But November 1st is coming fast.`}</p>
    <p>{`The fateful day arrives and we gotta run payroll. Do I re-engineer our entire system and fast track the development process to get this out in time for payroll and risk doing it all again when the API bug is fixed?`}</p>
    <p>{`Heck no!`}</p>
    <p>{`Time to hack.`}</p>
    <p><img parentName="p" {...{
        "src": "/a33157a516a8d0a0868e1bf0367e7884/media-3o7bugn9CywnjTFGIE-giphy.gif",
        "alt": "typing_fast giphy"
      }}></img></p>
    <p>{`In about two hours I came up with this wonderful piece of work.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/d36085439ed0b8201f6c5df504b6df1b/6e7c1/media-EIUgN6JXsAADe-i.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "81.1659192825112%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'324\\'%20viewBox=\\'0%200%20400%20324\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M26%20162c0%20123%200%20136%202%20136%203%202%20345%201%20346%200s2-265%200-270v-2H26v136\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/d36085439ed0b8201f6c5df504b6df1b/ca0a1/media-EIUgN6JXsAADe-i.webp 223w", "/static/d36085439ed0b8201f6c5df504b6df1b/75680/media-EIUgN6JXsAADe-i.webp 445w", "/static/d36085439ed0b8201f6c5df504b6df1b/8d1ba/media-EIUgN6JXsAADe-i.webp 890w", "/static/d36085439ed0b8201f6c5df504b6df1b/3838e/media-EIUgN6JXsAADe-i.webp 1335w", "/static/d36085439ed0b8201f6c5df504b6df1b/95342/media-EIUgN6JXsAADe-i.webp 1750w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/d36085439ed0b8201f6c5df504b6df1b/853b2/media-EIUgN6JXsAADe-i.jpg 223w", "/static/d36085439ed0b8201f6c5df504b6df1b/0a4fe/media-EIUgN6JXsAADe-i.jpg 445w", "/static/d36085439ed0b8201f6c5df504b6df1b/7f80b/media-EIUgN6JXsAADe-i.jpg 890w", "/static/d36085439ed0b8201f6c5df504b6df1b/dc6ba/media-EIUgN6JXsAADe-i.jpg 1335w", "/static/d36085439ed0b8201f6c5df504b6df1b/6e7c1/media-EIUgN6JXsAADe-i.jpg 1750w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/d36085439ed0b8201f6c5df504b6df1b/7f80b/media-EIUgN6JXsAADe-i.jpg",
              "alt": "media EIUgN6JXsAADe i",
              "title": "media EIUgN6JXsAADe i",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Ran that in Chrome DevTools logged in as admin on the 3rd party app, got the data dump, loaded it into Rails console on our server, and some 80 people got paid on time that day.`}</p>
    <p>{`💪`}</p>
    <h3 {...{
      "id": "how-it-works-1"
    }}>{`How it works`}</h3>
    <p>{`The idea behind this hack really is quite nasty.`}</p>
    <p>{`I searched through the app's UI to find a place that gives data in a timezone that we want. The schedule view instead of the payroll view.`}</p>
    <p>{`Their UI uses the same broken API as our backend, go figure.`}</p>
    <p>{`Once you have something in the HTML, you can use JavaScript to scrape it. 💡 And that's exactly what I did: Found some orienting classes and HTML ids ad wrote some vanilla JavaScript to read them.`}</p>
    <p>{`Now what? You can access the data, but how do you get it into your own system?`}</p>
    <p>{`Generate 300Kb of Ruby code and dump it straight into Chrome DevTools with a console.log of course. D'oh`}</p>
    <p>{`Then you copy paste that into production and save the day.`}</p>
    <p><img parentName="p" {...{
        "src": "/e96835d8f321ebde7ed7eb51c95e472e/media-hTQSzVR7yYW88-giphy.gif",
        "alt": "superman giphy"
      }}></img></p>
    <p>{`PS: The 3rd party has since decided that `}<em parentName="p">{`"different timezone for each row of data without timezone in the timestamp"`}</em>{` is the correct behavior. I want to murderize them. ❤️`}</p>
    <p>{`Happy Friday, ~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      